module.exports = __webpack_public_path__ + "img/case-tektronix.7e4886d6.png";